import React from 'react';
import { Github, Linkedin, Mail, ArrowUp } from 'lucide-react';
import { trackEvent } from '../utils/analytics';

export const Footer: React.FC = () => {
  const scrollToTop = () => {
    trackEvent('footer-scroll-to-top');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="py-12" style={{background:'linear-gradient( to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,.2) 100% )'}}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-8 md:mb-0">
            <h2 className="text-2xl font-bold mb-2 bg-gradient-to-r from-brand-gold1 to-brand-gold2 bg-clip-text text-transparent">Sudipta Dhara</h2>
            <p className="text-ink-dim">Software Developer & Generative AI Engineer</p>
          </div>
          
          <div className="mb-8 md:mb-0">
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <div className="grid grid-cols-2 gap-x-6 gap-y-2">
              <a 
                href="#home" 
                className="text-ink/70 hover:text-brand transition-colors"
                onClick={() => trackEvent('footer-home')}
                data-umami-event="footer-home"
              >
                Home
              </a>
              <a 
                href="#about" 
                className="text-ink/70 hover:text-brand transition-colors"
                onClick={() => trackEvent('footer-about')}
                data-umami-event="footer-about"
              >
                About
              </a>
              <a 
                href="#experience" 
                className="text-ink/70 hover:text-brand transition-colors"
                onClick={() => trackEvent('footer-experience')}
                data-umami-event="footer-experience"
              >
                Experience
              </a>
              <a 
                href="#skills" 
                className="text-ink/70 hover:text-brand transition-colors"
                onClick={() => trackEvent('footer-skills')}
                data-umami-event="footer-skills"
              >
                Skills
              </a>
              <a 
                href="#contact" 
                className="text-ink/70 hover:text-brand transition-colors"
                onClick={() => trackEvent('footer-contact')}
                data-umami-event="footer-contact"
              >
                Contact
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/in/sudipta26889" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-brand/20 p-3 rounded-full transition-colors"
                aria-label="LinkedIn Profile"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://github.com/sudipta26889"
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 p-3 rounded-full transition-colors"
                aria-label="GitHub Profile"
              >
                <Github size={20} />
              </a>
              <a 
                href="mailto:admin@sudiptadhara.in" 
                className="bg-white/10 hover:bg-red-600/80 p-3 rounded-full transition-colors"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>
        </div>
        
        <hr className="border-white/10 my-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-ink-dim mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Sudipta Dhara. All rights reserved.
          </p>
          
          <button 
            onClick={scrollToTop}
            className="bg-white/10 hover:bg-brand/30 p-3 rounded-full transition-colors"
            aria-label="Scroll to top"
            data-umami-event="footer-scroll-to-top"
          >
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};
